import { render, staticRenderFns } from "./FrameworkAccessReport.vue?vue&type=template&id=cbe7fae0"
import script from "./FrameworkAccessReport.vue?vue&type=script&lang=js"
export * from "./FrameworkAccessReport.vue?vue&type=script&lang=js"
import style0 from "./FrameworkAccessReport.vue?vue&type=style&index=0&id=cbe7fae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
